import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import dayjs from "dayjs"

export async function getConsultationsOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.CONSULTATIONS)

  data = await Promise.all(
    data.map(async (c) => {
      if (!c.patient || typeof c.patient !== "object") {
        const patient = await getByIdOffline(STORES.PATIENTS, c.patientId)
        return {
          ...c,
          patient: patient,
        }
      }
      return c
    }),
  )

  if (filters.nom) {
    data = data.filter((c) =>
      c.patient?.nom?.toLowerCase().includes(filters.nom.toLowerCase()),
    )
  }

  if (filters.prenom) {
    data = data.filter((c) =>
      c.patient?.prenom?.toLowerCase().includes(filters.prenom.toLowerCase()),
    )
  }

  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
